import { faX } from '@fortawesome/free-solid-svg-icons'
import { Button } from 'presentation/components/atoms/button'
import { Dialog } from 'presentation/components/atoms/dialog'
import { DialogActions } from 'presentation/components/atoms/dialogActions'
import { DialogContent } from 'presentation/components/atoms/dialogContent'
import { DialogTitle } from 'presentation/components/atoms/dialogTitle'
import { Icon } from 'presentation/components/atoms/Icon'
import { TextField } from 'presentation/components/molecules/textField/textField'
import { Controller, useForm } from 'react-hook-form'
import { isUrlValid } from 'utils/functionUtils'
import { validateEmail } from 'validations-br'

const fields = [
  {
    name: 'email',
    label: 'E-mail',
    placeholder: 'contato@empresa.com',
    rules: {
      required: {
        value: true,
        message: 'Campo requerido',
      },
      validate: {
        isValidEmail: (value) => validateEmail(value) || 'E-mail inválido',
      },
    },
  },
  {
    name: 'phone',
    label: 'Telefone',
    placeholder: '(00) 0000-0000',
    rules: {
      required: {
        value: true,
        message: 'Campo requerido',
      },
    },
  },
  {
    name: 'linkedin',
    label: 'LinkedIN',
    placeholder: 'https://www.linkedin.com...',
    rules: {
      validate: {
        isUrl: (value) => !value || isUrlValid(value) || 'Link inválido',
      },
    },
  },
  {
    name: 'instagram',
    label: 'Instagram',
    placeholder: 'https://www.instagram.com...',
    rules: {
      validate: {
        isUrl: (value) => !value || isUrlValid(value) || 'Link inválido',
      },
    },
  },
  {
    name: 'twitter',
    label: 'Twitter',
    placeholder: 'https://www.twitter.com...',
    rules: {
      validate: {
        isUrl: (value) => !value || isUrlValid(value) || 'Link inválido',
      },
    },
  },
]

export const CompanyContactsEditionDialog = ({ open, initialValue = {}, onSave, onClose }) => {
  const {
    control,
    handleSubmit,
    formState: { isDirty },
  } = useForm({
    defaultValues: initialValue,
  })

  const onSubmit = (data) => {
    if (isDirty) onSave(data)
    else onClose()
  }

  return (
    <Dialog open={open} maxWidth='lg' onClose={onClose}>
      <DialogTitle>
        Editar Informações de Contato
        <Icon icon={faX} onClick={onClose} sx={{ marginLeft: '130px' }} />
      </DialogTitle>
      <DialogContent>
        <form
          id='accountInfoEditForm'
          onSubmit={handleSubmit(onSubmit)}
          style={{
            display: 'flex',
            flexDirection: 'column',
            gap: '32px',
            margin: '32px 0',
          }}
        >
          {fields.map((field, index) => (
            <Controller
              control={control}
              name={field.name}
              rules={field.rules}
              key={`${index}_field_info_edit`}
              render={({ field: { value, onChange }, fieldState: { error, isDirty } }) => (
                <TextField
                  label={field.label}
                  value={value}
                  onChange={onChange}
                  placeholder={field.placeholder}
                  helperText={error?.message}
                  error={!!error}
                />
              )}
            />
          ))}
        </form>
      </DialogContent>
      <DialogActions sx={{ justifyContent: 'space-between' }}>
        <Button onClick={onClose}>Voltar</Button>
        <Button variant='contained' sx={{ width: '248px' }} type='submit' form='accountInfoEditForm'>
          Salvar
        </Button>
      </DialogActions>
    </Dialog>
  )
}
